// M7.3 — optional seam for `confirmFlow.kind === 'open-dialog'`.
//
// Production does not mount this provider. This repo has no dialog
// that runs M3's authorization chain (the agent chat confirmation
// card posts `confirmations` to /api/agent/chat only after the
// operator confirms a server-issued tool call). A nudge does not
// have that tool call, so Review for `open-dialog` stays disabled
// until a provider is mounted that opens that confirm UI and nothing
// else.
//
// There is no default opener. A missing provider is `null`, and the
// nudge refuses the click. Do not log-and-return — that was a dead
// path that looked like a handoff.

import { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';

export type AgentShellDialog = {
  // targetKey is a slug ("plan-draft"). prefill is initial state for
  // the confirm UI. The dialog owns the confirm; this seam only opens it.
  open: (targetKey: string, prefill?: Record<string, unknown>) => void;
};

const Ctx = createContext<AgentShellDialog | null>(null);

export function useAgentShellDialog(): AgentShellDialog | null {
  return useContext(Ctx);
}

export function AgentShellDialogProvider({
  dialog,
  children
}: {
  dialog:   AgentShellDialog;
  children: ReactNode;
}) {
  const value = useMemo<AgentShellDialog>(() => ({ open: dialog.open }), [dialog]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
